module.exports = __webpack_public_path__ + "static/media/dire-outlook.f247af83.png";